import { config } from "JS/Config";
import { BaseService } from "../BaseService";
import { ContentAttribute } from "JS/Models/Attributes";
import { appConstants } from "JS/Helpers/Constants";

export class AttributesService extends BaseService {
    getAttributesByContentType = (contentType: string) =>
        this.ngCall<ContentAttribute[]>(
            "get",
            appConstants.ngEndpoints.attributes(config.user.memberId),
            {
                params: {
                    contentType,
                    attributeName: "Speaker",
                },
            },
        );
}
